import * as React from "react";
import * as classNames from "classnames";
import { useHistory } from 'react-router-dom';

import { Authorization } from "../misc/components/Authorization";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import { useSecurityContext } from "../Core/SecurityContext";
import { useWebPortalApiClient, WebPortalApiClient } from "../misc/api/WebPortalTokenClient";
import { useInterval } from "../misc/Hooks/UseInterval";
import { useCurrentStudyConfigurationContext } from "../Core/CurrentStudyConfigurationContext";

interface AlertNotificationPopoutProps {
    currentStudyId: string;
}

function AdjustFavicon(isNotifying: boolean) {
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }
    link.href = isNotifying ? '/favicon-alert.ico' : '/favicon.ico';
}

export const AlertNotificationPopout = (props: AlertNotificationPopoutProps) => {
    const { currentUserPermissions } = useSecurityContext();
    const client = useWebPortalApiClient();
    const { study } = useCurrentStudyConfigurationContext();
    const [unReadAlerts, setUnReadAlerts] = React.useState<number>();
    const [modalOpen, setModalOpen] = React.useState<boolean>();
    const [isNotifying, setIsNotifying] = React.useState<boolean>(false);
    const history = useHistory();

    const getData = async (webPortalClient: WebPortalApiClient) => {
        const notifications = await webPortalClient.client.getAlertNotifications(undefined, `isRead eq false and alert/active eq true and (subscription/studyId eq ${study.id} or subscription/id eq null)`, undefined, undefined, 0, undefined, undefined, true);
        setUnReadAlerts(notifications["@odata.count"]);

        if (notifications["@odata.count"] > 0) {       
            setIsNotifying(true);
        } else {
            setIsNotifying(false);
        }
    }

    React.useEffect(() => {
        getData(client);
    }, []);

    React.useEffect(() => {
        AdjustFavicon(isNotifying);
    }, [isNotifying]);

    useInterval(() => getData(client), 60000);

    const handleIconClick = () => {
        history.push("/alerts");
    };

    const bellClasses = classNames("fas", "fa-bell", "fa-lg", {
        "alert-bell-off": !isNotifying,
        "alert-bell": isNotifying
    });

    const badgeClasses = classNames("badge", {
        "badge-primary": !isNotifying,
        "badge-info": isNotifying
    });

    if (!study)
        return null;

    return (
        <Authorization
            permissionId={PermissionEnum.ViewAlertNotifications}
            studyId={props.currentStudyId}
            currentPermissions={currentUserPermissions}
        >
            <li><a
                key="notificationMenu"
                id="notificationMenu"
                role="button"
                onClick={handleIconClick}
            >
                <span className={bellClasses} style={{ marginRight: 2 + "px" }} />
                <span className={badgeClasses}>{unReadAlerts}</span>
            </a></li>
        </Authorization>
    );
}


